<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    container-classes="container-fluid p-0"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" href="#pablo">
        {{ routeName }}
        <b class="text-danger fwb" v-if="!connectionStatus">
          SEI offline
        </b>
      </a>

      <div class="search-bar d-inline input-group" @click="openSearchModal()">
        <button
          class="btn btn-link"
          id="search-button"
          data-toggle="modal"
          data-target="#searchModal"
        >
          <i class="tim-icons icon-zoom-split"></i>
        </button>
      </div>
      <!-- {{queue}} -->
      <offline-queue
        @close="sidebarOfflineQueue = false"
        :show="sidebarOfflineQueue" />
    </div>
    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <modal
        :show.sync="searchModalVisible"
        class="modal-search"
        id="searchModal"
        :centered="false"
        :show-close="true"
      >
        <input
          slot="header"
          autocomplete="off" 
          v-model="searchQuery"
          type="text"
          @input="search"
          class="form-control"
          ref="inputSearchText"
          id="inlineFormInputGroup"
          placeholder="SEARCH"
        />
        <loading v-if="loading" class="m-auto"></loading>
        <div v-if="searchResults !== null" class="modal-body-content">
          <div class="row" v-if="searchResults.engines && searchResults.engines.length">
            <div
              class="col-12 search-result engines"
              :key="engine.id"
              v-for="engine in searchResults.engines">
              <div class="row">
                <router-link :key="engine._id" class="col-6 col-md-7" :to="`/sites/${engine.site}/engines/${engine._id}`" @click="searchQuery=''">
                  <h4 class="mb-0">
                    <b class="text-info">{{engine.name}}</b>
                    <b class="text-muted small"> <br class="d-inline d-md-none"> Motore</b>
                  </h4>
                  <b class="font-weight-normal text-dark">Matricola: {{engine.registrationNumber}}</b>
                  
                </router-link>
                <div class="col-6 col-md-5">
                  <router-link :key="engine.id" :to="`/engines/${engine._id}/revisions/create`"
                    @click="searchQuery=''"
                    class="btn btn-info w-100 btn-lg pl-0 pr-0">
                    <i class="tim-icons icon-settings"/>
                    Crea revisione
                  </router-link>

                </div>
              </div>
            </div>
          </div>
          <div
            class="row"
            v-if="searchResults.sites && searchResults.sites.length">
            <div
              class="col-12 search-result sites">
              <router-link
                :key="site.id"
                @click="searchQuery=''"
                v-for="site in searchResults.sites"
                :to="`/sites/${site._id}`">
                <h4 class="mb-0">
                  <b class="text-info">{{site.name}}</b>
                  <b class="text-muted small"> - cantiere</b>
                </h4>
                <b class="font-weight-normal text-dark">Cliente: {{site.clientName}}</b>
              </router-link>
            </div>
          </div>
          <div v-if="searchResults.error === true">
            Errore del server, riprovare fra poco
          </div>
          <div class="" v-if="searchResults.engines !== undefined && searchResults.engines.length === 0 && searchResults.sites !==undefined && searchResults.sites.length === 0">
            Nessun risultato trovato, prova con un altro termine di ricerca
          </div>
        </div>
      </modal>
      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template
          slot="title"
        >
          <div
            @click="sidebarOfflineQueue = !sidebarOfflineQueue">
            <div class="photo d-inline-block d-lg-none">
              <i class="tim-icons icon-planet"></i>
            </div>
            <p class="d-lg-none">Coda chiamate offline</p>
          </div> 
          <div>
            <div class="name-user-on--navbar d-none d-lg-block">{{account.user.name }} {{account.user.surname }}</div>
              <div class="photo"><i class="icon-single-02 tim-icons"></i></div>
              <b class="caret d-none d-lg-block d-xl-block"></b>
              <p class="d-lg-none">{{account.user.name }} {{account.user.surname }}</p>
          </div>

        </template>
        <li class="nav-link">
          <router-link to="/pages/user" class="nav-item dropdown-item">Profilo personale</router-link>
        </li>
        <li class="nav-link">
          <router-link to="/login" class="nav-item dropdown-item">Log out</router-link>
        </li>
        <li
          class="nav-link d-none d-md-block"
          @click="sidebarOfflineQueue = !sidebarOfflineQueue">
          <span class="nav-item dropdown-item">
            <i class="tim-icons icon-planet"></i> 
            Coda chiamate offline
          </span>
        </li> 

      </base-dropdown> 
    </ul>
  </base-nav>
</template>
<style lang="scss">
  .name-user-on--navbar {
    position: absolute;
    right: 60px;
    font-weight: bold;
    top: 10px;
  }
  .modal-body-content{
    margin-top: -15px;
  }
  .fwb{
    font-weight: bold !important;
  }
  .search-result{
    border-bottom: 1px solid rgba(#999,0.5);
    &.engines a,
    &.sites a{
      display: block;
      padding-top: 15px;
      padding-bottom: 15px;
    }
    &.sites a{
      padding: 15px;
      margin: 0  -15px;
    }
    
    &:nth-child(2n){
      background:rgba(#999,0.14);
    }
    &.sites,a{
      transition: all .5s,
    }
    & a:hover{
      
      background: rgba(#999,0.3);
    }
  }
</style>
<script>
import { debounce } from "debounce"
import axios from '@/axios'
import { mapState } from 'vuex'
import { CollapseTransition } from 'vue2-transitions'
import { BaseNav, Modal } from '@/components'
import SidebarToggleButton from './SidebarToggleButton'
import offlineQueue from './OfflineQueue.vue'

export default {
  components: {
    SidebarToggleButton,
    CollapseTransition,
    BaseNav,
    Modal,
    offlineQueue
  },
  computed: {
    ...mapState({
      account: state => state.account,
    }),
    ...mapState({
      connectionStatus: state => state.offline.connectionStatus,
      queue: state => state.offline.queue
    }),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      sidebarOfflineQueue: false,
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      loading: false,
      searchResults: null
    };
  },
  watch:{
    $route (to, from){
        this.searchModalVisible = false;
        this.searchQuery = ''
    }
  }, 
  methods: {
    search: debounce( async function({target}) {
      this.loading=true;
      if (target.value){
        try {
          const res = await axios.get(`/api/search/${target.value}`)
          this.searchResults = res.data;
          this.loading=false;
        } catch (e){
          console.error(e);
          this.loading=false;
          this.searchResults = {
            error: true,
            e
          };
        }
      }
    },500),
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    openSearchModal(){
      const vm = this;
      this.searchModalVisible = true
      setTimeout(function(){
        vm.$refs.inputSearchText.focus()
      },400)
    }
  }
};
</script>
<style scoped lang="scss">
.top-navbar {
  top: 0px;
  @media(max-width: 768px){
    padding: 10px 0;
    > .container-fluid{
      padding: 0 !important;
    }
    .search-bar{
      position: absolute;
      right: 44px;
      left: auto;
      top: 7px;
      width: 45px;
      #search-button{
        margin:0;
      }
    }
    .navbar-toggler{
      padding-left: 15px;
      padding-right: 15px;
    }
    .search-bar,
    .navbar-brand{
      margin:0;
    }
  }
}

</style>
